let viewer;
let optionValues;
let materialNames;
var materialChangeStatus = {};

const optionOrder = {
  "Wood Finish": 0,
  "Metal Finish": 1,
  "Column": 2,
  "Column Finish": 3,
  "Fabric": 5,
  "Metal": 4,
};

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getFileNameFromUrl(url) {
  let urlObj = new URL(url);

  let pathname = urlObj.pathname;

  let imageName = pathname.split("/").pop();

  imageName = imageName.split("?")[0];
  imageName = imageName.split("#")[0];

  return imageName;
}

function checkIfMaterialsAllChanged() {
  let allowMaterialChange = true;

  if (Object.keys(materialChangeStatus).length > 0) {
    for (let key in materialChangeStatus) {
      if (!materialChangeStatus[key]) {
        allowMaterialChange = false;
      }
    }
  }

  return allowMaterialChange;
}

function sortOptionOrder(option1, option2) {
  let sort1 = 999;

  if (optionOrder.hasOwnProperty(option1.name)) {
    sort1 = optionOrder[option1.name];
  }

  let sort2 = 999;

  if (optionOrder.hasOwnProperty(option2.name)) {
    sort2 = optionOrder[option2.name];
  }

  if (sort1 > sort2) {
    return 1;
  } else {
    return -1;
  }
}

function takeScreenShot() {
  var productId = $('input[name="product-id"]').val();

  setTimeout(function () {
    viewer.takeScreenShotBase64().then((result) => {
      console.log(result);

      if (result) {
        localStorage.setItem("cart_img_base64_" + productId, result);
      }
    });
  }, 1600);
}

function getOpitons(components) {
  let options = [];

  for (var i = 0; i < components.length; i++) {
    const component = components[i];

    var materials = [];

    let materials_data = components[i]["materials"];

    console.log(materials_data);

    for (var j = 0; j < materials_data.length; j++) {
      const material_data = materials_data[j];

      if (
        material_data.thumbnail != "" &&
        material_data.name != "Default" &&
        typeof material_data.name !== "undefined"
      ) {
        let imageFile = getFileNameFromUrl(material_data.thumbnail);
        console.debug(imageFile);
        let zoomIn = "https://img.chromcrafthome.com/" + imageFile;

        const material = {
          name: material_data.name,
          materialId: material_data.id,
          thumbnail:
            material_data.thumbnail + "?x-oss-process=image/resize,m_fill,w_64",
          zoomin:
            material_data.thumbnail +
            "?x-oss-process=image/resize,m_fill,w_512", //zoomIn
        };

        materials.push(material);
      }
    }

    materials.sort((a, b) => {
      const aNumber = Number(a.name);
      const bNumber = Number(b.name);

      if (aNumber > bNumber) {
        return 1;
      } else if (aNumber < bNumber) {
        return -1;
      } else {
        return 0;
      }
    });

    const option = {
      name: component.name,
      materials: materials,
      componentIdStr: component.componentIds.join(","),
    };

    options.push(option);
  }

  options.sort(sortOptionOrder);

  return options;
}

function buildPanel(options) {
  let html = "";

  html += "<div class='cohoom-panel-content'>";

  options.forEach(function (option) {
    const materials = option.materials;

    html += "<div class='cohoom-option'>";
    html +=
      "<div class='cohoom-option-name'><span>" +
      option.name +
      "</span><i class='fa-solid fa-circle-check'></i></div>";

    html += "<div class='cohoom-option-content'>";

    materials.forEach(function (material) {
      if (!material.name.includes("默认") && material.name != material.materialId) {  //if (!material.name.includes("默认")) {
        html +=
          "<div class='cohoom-block' data-material-zoomin='" +
          material.zoomin +
          "' data-option-name='" +
          option.name +
          "' data-component-id-str='" +
          option.componentIdStr +
          "' data-material-id='" +
          material.materialId +
          "'>";
        html +=
          "<img class='cohoom-material-thumbnail' src='" +
          material.thumbnail +
          "'/>";
        html += "<div class='cohoom-material-name'>" + material.name + "</div>";
        html += "</div>";
      }
    });

    html += "</div>";
    html += "</div>";
  });

  html += "</div>";

  html += "<div class='cohoom-panel-clear' onclick='hidePanel()'></div>";

  $("#cohoom-panel").append(html);
}

function buildMaterialNames(options) {
  let materialNames = {};

  for (var i = 0; i < options.length; i++) {
    let materials = options[i]["materials"];

    for (var j = 0; j < materials.length; j++) {
      const material = materials[j];
      materialNames[material.materialId] = material.name;
    }
  }

  return materialNames;
}

function buildOptionValues(opitons) {
  let optionValues = {};

  opitons.forEach(function (opiton) {
    optionValues[opiton.name] = null;
  });

  return optionValues;
}

function generateOptionDescription() {
  let description = "";

  const keys = Object.keys(optionValues);

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = optionValues[key];

    description += key + ": " + materialNames[value];

    if (i < keys.length - 1) {
      description += ", ";
    }
  }

  return description;
}

function validateOptionSelect() {
  let validated = true;

  const keys = Object.keys(optionValues);

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (optionValues[key] == null) {
      validated = false;
      break;
    }
  }

  return validated;
}

function validateAddCart() {
  let validated = true;

  const keys = Object.keys(optionValues);

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (optionValues[key] == null) {
      validated = false;
      break;
    }
  }

  if (validated) {
    $(".cart-btn-cover").remove();
    $('button[name="add"]').prop("disabled", false);
    $("#show-sticky-product").prop("disabled", false);
  }
}

function loadCohoomView(modelId) {
  let variantId = window.location.search.split('variant=')[1];
  const idKey = (modelId && modelId.length === 12) ? 'modelId' : 'kpxGroupId';
  if (modelId.length < 2){
    $(".cohoom-wrap").remove();
  }
  else {
  viewer = new koolViewer.ViewerUISDK({
    mount: document.getElementById("cohoom-model"),
    apiSource: 'prod',
    [idKey]: modelId,
    autoRotate: true,
    useCoohomAPI: false,
    useCoohomCDN: true,
    enablePanel: false,
    enableOperationPanel: true,
    textureSize: 512,
    textureQuality: 50,
    lengthUnit: 'in',
    locale: 'en_US',
    enableWireFrame: false,
    enableArIcon: false,
    enableShareIcon: false,
    showRuler: false,    
    async afterDidMount() {
      let componentsObj = {};

      const componentsData = viewer.getComponents();

      componentsData.forEach(function (component) {
        const key = component.name;

        if (typeof componentsObj[key] === "undefined") {
          componentsObj[key] = {
            name: component.name,
            materials: component.materials,
            componentIds: [],
          };
        }

        componentsObj[key].componentIds.push(component.id);
      });

      let components = [];

      Object.keys(componentsObj).forEach((key) => {
        components.push(componentsObj[key]);
      });

      const options = getOpitons(components);

      buildPanel(options);

      optionValues = buildOptionValues(options);
      materialNames = buildMaterialNames(options);

      $(".skeleton-content").remove();
      $("#cohoom-model-skeleton").remove();

/*       $(".cohoom-model-wrap").append(
        '<img class="cohoom-usa" src="https://cdn.shopify.com/s/files/1/0808/3193/8871/files/usa-v2.png">'
      ); */
    },
  });
}
}

function togglePanel() {
  let panel = $("#cohoom-panel");

  if (panel.hasClass("animate__fadeInLeft")) {
    panel.removeClass("animate__fadeInLeft");
    panel.addClass("animate__fadeOutLeft");
  } else {
    panel.removeClass("animate__fadeOutLeft");
    panel.addClass("animate__fadeInLeft");
    panel.show();
  }
}

function hidePanel() {
  let panel = $("#cohoom-panel");
  panel.removeClass("animate__fadeInLeft");
  panel.addClass("animate__fadeOutLeft");
}

$(document).on("click", ".cohoom-block", function () {
  if (checkIfMaterialsAllChanged()) {
    //add loading effect
    //html = '<div id="cohoom-model-skeleton">';
    //html += '<div class="skeleton-block"></div>';
    //html += '</div>';
    //$(".cohoom-model-wrap").append(html);

    //add material select effect
    $(this)
      .closest(".cohoom-option")
      .find(".fa-circle-check")
      .css("color", "#033c5a");
    $(this)
      .closest(".cohoom-option")
      .find(".cohoom-material-thumbnail")
      .removeClass("cohoom-material-thumbnail-selected");
    $(this)
      .find(".cohoom-material-thumbnail")
      .addClass("cohoom-material-thumbnail-selected");

    //get data
    const optionName = $(this).attr("data-option-name");
    const materialId = $(this).attr("data-material-id");
    const zoomin = $(this).attr("data-material-zoomin");
    const componentIdStr = $(this).attr("data-component-id-str");

    //change mateirals
    materialChangeStatus = {};
    let isMaterialChangeInProgress = false;
    const componentIds = componentIdStr.split(",");

    for (componentId of componentIds) {
      materialChangeStatus[componentId] = false;
    }

    //for (componentId of componentIds) {
    //  if (!isMaterialChangeInProgress) { // Check if a change is already in progress
    //    isMaterialChangeInProgress = true; // Set to true to block new changes
    //    viewer.changeMaterial(componentId, materialId).promise.then(() => {
    //      $('#cohoom-model-skeleton').remove();
    //      materialChangeStatus[componentId] = true;
    //      isMaterialChangeInProgress = false; // Reset the flag after completion
    //    }).catch((error) => {
    //      // Handle the error, especially the abort event
    //      if (error.type === 'abort') {
    //        console.warn('Request was aborted:', error);
    //        console.warn('Request was aborted:', componentId + " AND " + materialId);
    //        // Handle the abort specifically, e.g., provide user feedback or clean up
    //      } else {
    //        console.error('An unexpected error occurred:', error);
    //      }
    //      isMaterialChangeInProgress = false; // Ensure flag is reset on error
    //    });
    //  } else {
    //    console.warn('A material change is already in progress. Ignoring this request.');
    //  }
    //}

  



    
    async function processComponentIds(componentIds) {
      for (componentId of componentIds) {
        if (!isMaterialChangeInProgress) {
          isMaterialChangeInProgress = true;
          try {
            await viewer.changeMaterial(componentId, materialId).promise;
            $("#cohoom-model-skeleton").remove();
            materialChangeStatus[componentId] = true;
          } catch (error) {
            // Handle errors, including aborted requests
            if (error.type === "abort") {
              console.warn(
                "Request was aborted:",
                componentId + " , " + materialId
              );
            } else {
              console.error("An unexpected error occurred:", error);
            }
          } finally {
            isMaterialChangeInProgress = false;
          }
        } else {
          console.warn(
            "A material change is already in progress. Ignoring this request."
          );
        }
      }
    }

    // Usage:
    processComponentIds(componentIds).catch((error) => {
      // Handle any uncaught errors
    });
    //write option data
    optionValues[optionName] = materialId;
    const optionDescription = generateOptionDescription();
    $("#material").val(optionDescription);

    //validate cart
    validateAddCart();

    //store current view
    takeScreenShot();
  }
});

function handleBtnCoverClick() {
  $(".cohoom-alert-wrap").remove();

  let alertMessage = "Please select ";

  let notSelectedMaterials = [];

  Object.entries(optionValues).forEach(([key, value]) => {
    if (value == null) {
      notSelectedMaterials.push(key);
    }
  });

  alertMessage += notSelectedMaterials.join(", ");
  alertMessage += " in the material panel";

  let alertElement =
    '<div class="cohoom-alert-wrap animate__animated animate__fadeInDown animate__faster">';
  alertElement += '<div class="cohoom-alert-inner">' + alertMessage + "</div>";
  alertElement += "</div>";

  $("body").append(alertElement);

  setTimeout(function () {
    $(".cohoom-alert-wrap").removeClass("animate__fadeInDown");
    $(".cohoom-alert-wrap").addClass("animate__fadeOutUp");
  }, 3000);
}

$(document).ready(function () {
  
  $(document).on("mouseenter", ".cohoom-block", function () {
    if (window.innerWidth > 768) {
      const zoomin = $(this).attr("data-material-zoomin");

      $("#cohoom-material-zoomin").remove();
      let zoomInImage =
        '<div id="cohoom-material-zoomin" class="animate__animated animate__fadeIn" style="background-image: url(' +
        zoomin +
        ')"></div>';
      $(".cohoom-wrap").append(zoomInImage);
    }
  });

  $(document).on("mouseleave", ".cohoom-block", function () {
    $("#cohoom-material-zoomin").remove();
  });

  let cartButtonCover = $(
    '<div class="cart-btn-cover" onclick="handleBtnCoverClick()"><span></span></div>'
  );
  $(".product-form__buttons").append(cartButtonCover);

  let cartButtonCoverStick = $(
    '<div class="cart-btn-cover" onclick="handleBtnCoverClick()"><span></span></div>'
  );
  $(".empty-add-cart-button-wrapper").css("position", "relative");
  $(".empty-add-cart-button-wrapper").append(cartButtonCoverStick);

  $('button[name="add"]').prop("disabled", true);
  $("#show-sticky-product").prop("disabled", true);
});

